import { Rpc, RpcGroup } from "effect/rpc";
import {
  KioskCreatePatientRequest,
  KioskCreatePatientResponse,
  KioskPatientCreationRejected,
} from "./create-patient.schema";
import {
  KioskCreatePrescriptionRequest,
  KioskCreatePrescriptionResponse,
  KioskPrescriptionRequestRejected,
} from "./prescription-request.schema";

/**
 * Policy-governed mutation operations reachable by FrontDesk+ kiosks.
 *
 * @since 1.2.0
 * @example
 * ```ts
 * import { FrontDeskKioskOperationsRpcs } from "@ascleo/frontdesk-contracts/kiosk-operations/rpc";
 *
 * const operationCount = FrontDeskKioskOperationsRpcs.requests.size;
 * ```
 */
export class FrontDeskKioskOperationsRpcs extends RpcGroup.make(
  Rpc.make("FrontDeskCreatePatient", {
    success: KioskCreatePatientResponse,
    error: KioskPatientCreationRejected,
    payload: KioskCreatePatientRequest,
  }),
  Rpc.make("FrontDeskCreatePrescriptionRequest", {
    success: KioskCreatePrescriptionResponse,
    error: KioskPrescriptionRequestRejected,
    payload: KioskCreatePrescriptionRequest,
  }),
) {}
